import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import OvCompactButton from '../atoms/OvCompactButton';
import { AdminVideo } from '../../../common/model/dto/video/admin-video';

interface OvVideoEditOrderButtonProps {
  video: AdminVideo;
  onEdit: (video: AdminVideo) => void;
}

const OvVideoEditOrderButton: FC<OvVideoEditOrderButtonProps> = ({
  video,
  onEdit,
}) => {
  const { t } = useTranslation();

  return (
    <Wrapper>
      <OvCompactButton
        tone="secondary"
        aria-label={t('videos.list.editOrderOf', { title: video.title })}
        onClick={() => onEdit(video)}
      >
        {t('videos.list.editOrder')}
      </OvCompactButton>
    </Wrapper>
  );
};

export default OvVideoEditOrderButton;

const Wrapper = styled.div`
  margin-top: 0.25rem;
`;
